var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1909 3.67188L14.2612 0.742188C13.7925 0.273438 13.1675 0 12.5034 0H5.43311C4.02686 0 2.93311 1.13281 2.93311 2.5V17.5C2.93311 18.9062 4.02686 20 5.43311 20H15.4331C16.8003 20 17.9331 18.9062 17.9331 17.5V5.42969C17.9331 4.76562 17.6597 4.14062 17.1909 3.67188ZM16.0581 17.5C16.0581 17.8516 15.7456 18.125 15.4331 18.125H5.43311C5.08154 18.125 4.80811 17.8516 4.80811 17.5V2.53906C4.80811 2.1875 5.08154 1.91406 5.43311 1.91406H11.6831V5C11.6831 5.70312 12.23 6.25 12.9331 6.25H16.019V17.5H16.0581ZM6.68311 10.9375C6.68311 11.4844 7.07373 11.875 7.62061 11.875H13.2456C13.7534 11.875 14.1831 11.4844 14.1831 10.9375C14.1831 10.4297 13.7534 10 13.2456 10H7.62061C7.07373 10 6.68311 10.4297 6.68311 10.9375ZM13.2456 13.75H7.62061C7.07373 13.75 6.68311 14.1797 6.68311 14.6875C6.68311 15.2344 7.07373 15.625 7.62061 15.625H13.2456C13.7534 15.625 14.1831 15.2344 14.1831 14.6875C14.1831 14.1797 13.7534 13.75 13.2456 13.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListFile);
export default __webpack_public_path__ + "static/media/ListFile.e88c09548ad1a008e3c8d95639df9b7e.svg";
export { ForwardRef as ReactComponent };